export default {
  PREFERRED_ENV_FOR_FAVORITES: 'perfered_environment_for_favorites',
  TILE_LABELS: 'tile_labels',
  TRACK_PROGRESS: 'track_progress',
  FETCH_PROGRESS: 'fetch_progress',
  FAVORITE_PODCAST_EPISODES: 'favorite_podcast_episodes',
  RECENTLY_PLAYED_TILES: 'recently_played_tiles',
  DARK_THEME: 'dark_theme',
  SIMPLIFIED_MOBILE_HEADER: 'simplified_mobile_header',
  OVERVIEW_WITH_REFERENCES_TEST: 'overview_with_references',
};
